module.exports = __webpack_public_path__ + "static/img/06004B_1_2_C_20230508_LC.fd7b119.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/06004B_1_2_C_20230508_LC.png
// module id = 65r7
// module chunks = 0